const o = Symbol.for("motionComponentSymbol");
export {
  o as motionComponentSymbol
};
